"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthorizedOptimetriksRoles = exports.getAuthorizedRoles = void 0;
const optimetriksRoles_1 = require("./optimetriksRoles");
const lodash_1 = __importDefault(require("lodash"));
const getAuthorizedRoles = (profiles, userRole) => {
    if ((0, optimetriksRoles_1.isOptimetriksRole)(userRole)) {
        return [
            ...lodash_1.default.map(profiles, "name"),
            ...(0, exports.getAuthorizedOptimetriksRoles)(userRole),
        ];
    }
    const userProfile = lodash_1.default.find(profiles, { name: userRole });
    if (!userProfile) {
        return [];
    }
    let nbActionsAvailable = 0;
    for (const act in userProfile.actions) {
        if (userProfile.actions[act]) {
            nbActionsAvailable++;
        }
    }
    const authorizedRoles = [userRole];
    lodash_1.default.each(profiles, (profile) => {
        if (profile.name === userRole) {
            return;
        }
        let actionCount = 0;
        for (const act in profile.actions) {
            if (profile.actions[act]) {
                actionCount++;
            }
        }
        if (nbActionsAvailable > actionCount) {
            authorizedRoles.push(profile.name);
        }
    });
    return authorizedRoles;
};
exports.getAuthorizedRoles = getAuthorizedRoles;
const getAuthorizedOptimetriksRoles = (userRole) => {
    switch (userRole) {
        case optimetriksRoles_1.OPTIMETRIKS_ROLES.SUPERADMIN: {
            return [optimetriksRoles_1.OPTIMETRIKS_ROLES.ADMIN, optimetriksRoles_1.OPTIMETRIKS_ROLES.OPERATION];
        }
        case optimetriksRoles_1.OPTIMETRIKS_ROLES.ADMIN: {
            return [optimetriksRoles_1.OPTIMETRIKS_ROLES.OPERATION];
        }
        case optimetriksRoles_1.OPTIMETRIKS_ROLES.OPERATION: {
            return [];
        }
        default: {
            return [];
        }
    }
};
exports.getAuthorizedOptimetriksRoles = getAuthorizedOptimetriksRoles;
